import { render, staticRenderFns } from "./MenuChat.vue?vue&type=template&id=37633a6d&scoped=true"
import script from "./MenuChat.vue?vue&type=script&lang=js"
export * from "./MenuChat.vue?vue&type=script&lang=js"
import style0 from "./MenuChat.vue?vue&type=style&index=0&id=37633a6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37633a6d",
  null
  
)

export default component.exports